/* kápsula — cronômetro da oferta e abas de marca da busca por modelo */

(() => {
  /* Cronômetro: conta até data-end (AAAA-MM-DD HH:MM, horário de Brasília).
     Data inválida ou oferta encerrada = cronômetro escondido. */
  if (!customElements.get('kp-countdown')) {
    class KpCountdown extends HTMLElement {
      connectedCallback() {
        const raw = (this.dataset.end || '').trim();
        const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
        if (!m) return;
        const [, y, mo, d, h = '23', mi = '59'] = m;
        this.end = new Date(`${y}-${mo}-${d}T${h}:${mi}:00-03:00`).getTime();
        if (Number.isNaN(this.end)) return;
        this.h = this.querySelector('[data-unit="h"]');
        this.m = this.querySelector('[data-unit="m"]');
        this.s = this.querySelector('[data-unit="s"]');
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      tick() {
        const left = Math.floor((this.end - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(this.timer);
          this.hidden = true;
          if (this.dataset.hideSection === 'true') {
            const section = this.closest('.shopify-section');
            if (section && !window.Shopify?.designMode) section.hidden = true;
          }
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        this.h.textContent = pad(Math.floor(left / 3600));
        this.m.textContent = pad(Math.floor((left % 3600) / 60));
        this.s.textContent = pad(left % 60);
        this.hidden = false;
      }
    }
    customElements.define('kp-countdown', KpCountdown);
  }

  /* Abas de marca (Apple, Samsung...) com teclado */
  if (!customElements.get('kp-tabs')) {
    class KpTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next !== null) {
              e.preventDefault();
              this.select(next);
              this.tabs[next].focus();
            }
          });
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('kp-tabs', KpTabs);
  }

  /* No editor de temas: ao clicar num bloco de marca, abre a aba dele */
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab) tab.click();
  });
})();
